// Third party dependencies.
import React from 'react';
import { Text as RNText } from 'react-native';

// Internal dependencies.
import { TextProps } from './Text.types';
import styleSheet from './Text.styles';
import { DEFAULT_TEXT_COLOR, DEFAULT_TEXT_VARIANT } from './Text.constants';
import { useStyles } from '../../../hooks/useStyles';

const Text: React.FC<TextProps> = ({
  variant = DEFAULT_TEXT_VARIANT,
  color = DEFAULT_TEXT_COLOR,
  style,
  children,
  ...props
}) => {
  const { styles } = useStyles(styleSheet, { variant, style, color });
  return (
    <RNText {...props} style={styles.base} accessibilityRole="text">
      {children}
    </RNText>
  );
};

export default Text;
